import React from 'react'
import { CardContent, Typography } from "@mui/material";

export default function CardHintCmp(props: any) {
  return (
    <CardContent
      sx={{
        background: `#F1F4FF`,
        textAlign: "justify",
        borderRadius: "10px",
        marginBottom: "18px",
        //   marginTop: "-10px",
        border: "1px solid #DAE0E4",
        boxShadow: "1px 2px #dae0e4",
        width: "100%",
        // paddingBottom: '5px',
        paddingTop: '24px',
        verticalAlign: 'center',

      }}
    >
      <Typography color="text.secondary" gutterBottom>
        <div style={{ fontFamily: "iranSans", color: "#1D4A87" }}
          className={props.fontSize != undefined ? props.fontSize : "textFont16"}>
          {props.icon} {props.title}
        </div>
      </Typography>
    </CardContent>
  )
}
